// 0원 처리를 위한 공통 유틸리티 함수들

/**
 * 금액을 표시용으로 포맷팅 (0원은 "0"으로 표시, 빈 값은 ""으로 표시)
 * @param val - 포맷팅할 값
 * @returns 포맷팅된 문자열
 */
export function formatAmountDisplay(val: any): string {
  if (val === undefined || val === null || val === '') return '';
  const num = Number(String(val).replace(/[^\d.-]/g, ''));
  if (isNaN(num)) return val;
  return num.toLocaleString('ko-KR');
}

/** 입력 중 실시간 금액 포맷 (#,##0) */
export function formatAmountKoreanInput(raw: string): string {
  const digits = String(raw).replace(/[^\d]/g, '');
  if (!digits) return '';
  return Number(digits).toLocaleString('ko-KR');
}

/**
 * 금액을 안전하게 숫자로 변환 (빈 값은 0으로, 0은 0으로 유지)
 * @param val - 변환할 값
 * @returns 숫자
 */
export function safeAmountToNumber(val: any): number {
  if (val === undefined || val === null || val === '') return 0;
  const num = Number(String(val).replace(/[^\d.-]/g, ''));
  return isNaN(num) ? 0 : num;
}

/**
 * 금액 입력값을 처리 (빈 값은 빈 문자열, 숫자는 그대로)
 * @param val - 입력값
 * @returns 처리된 값
 */
export function processAmountInput(val: any): string | number {
  if (val === undefined || val === null || val === '') return '';
  const num = Number(String(val).replace(/[^\d.-]/g, ''));
  return isNaN(num) ? val : num;
}

/**
 * 금액이 0원인지 확인
 * @param val - 확인할 값
 * @returns 0원 여부
 */
export function isZeroAmount(val: any): boolean {
  if (val === undefined || val === null || val === '') return false;
  const num = Number(String(val).replace(/[^\d.-]/g, ''));
  return !isNaN(num) && num === 0;
}

/**
 * 금액이 빈 값인지 확인
 * @param val - 확인할 값
 * @returns 빈 값 여부
 */
export function isEmptyAmount(val: any): boolean {
  return val === undefined || val === null || val === '';
}
